<template>
  <div class="w-full custom-height">
    <div class="w-full overflow-y-auto overflow-x-hidden px-3">
      <el-form
        ref="formAdd"
        label-width="80px"
        label-position="left"
        :rules="rules"
        :model="formData"
      >
        <el-form-item label="模板名称" prop="templateName">
          <el-input
            class="w-full"
            v-model="formData.templateName"
            placeholder="请输入模板名称"
            maxlength="50"
            show-word-limit
          ></el-input>
        </el-form-item>
        <p class="font-bold mb-5">请勾选所需资质模板类型</p>
        <el-form-item class="form-nolabel" prop="value">
          <el-row type="flex" justify="space-between" align="middle">
            <el-col :span="11">
              <div class="flex mb-10px justify-between">
                <div class="mb-10px">
                  <el-input
                    size="small"
                    class="mr-10px !w-50"
                    placeholder="请输入标题"
                    v-model="searchData.title"
                    clearable
                  ></el-input>
                  <el-select
                    v-model="searchData.directoryId"
                    size="small"
                    class="mr-10px !w-50"
                    placeholder="请选择资质类别"
                    clearable
                  >
                    <el-option
                      v-for="item in typeList"
                      :key="item.id"
                      :label="item.name"
                      :value="item.id"
                    ></el-option>
                  </el-select>
                  <el-button size="small" type="primary" @click="handleSearch">搜索</el-button>
                </div>
              </div>
              <el-table
                ref="tables"
                :data="dataList"
                border
                class="w-full"
                height="400px"
                @selection-change="selectChange"
              >
                <el-table-column
                  type="selection"
                  width="50"
                  align="center"
                  :selectable="isDisabled"
                ></el-table-column>
                <el-table-column
                  label="标题"
                  align="center"
                  prop="title"
                  show-overflow-tooltip
                ></el-table-column>
                <el-table-column
                  label="资质类别"
                  align="center"
                  prop="directoryName"
                  show-overflow-tooltip
                >
                  <template #header> <span class="pr-10px">资质类别</span>{{ number }} </template>
                </el-table-column>
              </el-table>
            </el-col>
            <el-col :span="2" class="ml-5 mr-5 text-center">
              <el-button
                type="primary"
                icon="iconfont icon-line-right"
                class="button-normal"
                :disabled="disabledChoose"
                size="small"
                @click="choose"
              ></el-button>
            </el-col>
            <el-col :span="11">
              <div class="flex mb-10px justify-between">
                <div class="mb-10px">
                  <el-input
                    size="small"
                    class="mr-10px !w-50"
                    placeholder="请输入标题"
                    v-model="searchChooseData.title"
                    clearable
                  ></el-input>
                  <el-select
                    v-model="searchChooseData.directoryId"
                    size="small"
                    class="mr-10px !w-50"
                    placeholder="请选择资质类别"
                    clearable
                  >
                    <el-option
                      v-for="item in typeList"
                      :key="item.id"
                      :label="item.name"
                      :value="item.name"
                    ></el-option>
                  </el-select>
                  <el-button size="small" type="primary" @click="handleChooseData">搜索</el-button>
                </div>
              </div>
              <el-table class="w-full" :data="chooseFilterList" border height="400px">
                <el-table-column
                  label="标题"
                  align="center"
                  prop="title"
                  show-overflow-tooltip
                ></el-table-column>
                <el-table-column
                  label="资质类别"
                  align="center"
                  prop="directoryName"
                  show-overflow-tooltip
                >
                  <template #header> <span class="pr-10px">资质类别</span>{{ count }} </template>
                </el-table-column>
                <el-table-column label="操作" align="center" width="80">
                  <template slot-scope="scope">
                    <el-button size="mini" @click="handleDel(scope.row)">删除</el-button>
                  </template>
                </el-table-column>
              </el-table>
            </el-col>
          </el-row>
        </el-form-item>
        <el-form-item class="form-nolabel">
          <div class="text-center w-full h-10 leading-10 mt-10px">
            <el-button size="small" type="primary" @click="handleSave" :loading="formLoading"
              >保存</el-button
            >
            <el-button size="small" @click="$emit('cancel')">取消</el-button>
          </div>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>
import {
  GuidanceConfigurationApi,
  GuidanceConfigurationDirectoryApi,
  ProfileTemplateConfigurationApi,
  ProfileTemplateGuidanceConfigurationApi,
} from '@wiz-api/contractor-management'
import { uniqBy, find, differenceBy } from 'lodash'

const guidanceConfigurationApi = new GuidanceConfigurationApi()
const guidanceConfigurationDirectoryApi = new GuidanceConfigurationDirectoryApi()
const profileTemplateConfigurationApi = new ProfileTemplateConfigurationApi()
const profileTemplateGuidanceConfigurationApi = new ProfileTemplateGuidanceConfigurationApi()

export default {
  name: 'project-form',
  props: {
    pageType: {
      type: String,
      default: 'create',
    },
    FormData: {
      type: Object,
      default: () => {},
    },
  },
  created() {
    // 获取模板配置资料
    this.getConfigList()
    // 获取配置列表
    this.getTypeList()
  },
  data() {
    return {
      chooseTypeList: [],
      typeList: [],
      value: true,
      selection: [],
      searchData: {
        directoryId: '',
        title: '',
        // 是否排除人员指引配置
        excludePersonConfig: true,
      },
      searchChooseData: {
        title: '',
        directoryId: '',
      },
      formLoading: false,
      formData: null,
      rules: {
        templateName: [{ required: true, message: '请输入项目编号', trigger: 'blur' }],
      },
      // 选中资质模板过滤后显示的字段
      chooseFilterList: [],
      dataList: [],
    }
  },
  computed: {
    number() {
      console.log(`${this.formData.chooseList.length}/${this.dataList.length}`, '123')
      return `${this.formData.chooseList.length}/${this.dataList.length}`
    },
    count() {
      console.log(`${this.formData.chooseList.length}/${this.formData.chooseList.length}`, '123')
      return `${this.formData.chooseList.length}/${this.formData.chooseList.length}`
    },
    disabledChoose() {
      return differenceBy(this.dataList, this.formData.chooseList, 'id').length === 0
    },
  },
  watch: {
    FormData: {
      handler(newVal, oldVal) {
        this.formData = newVal
        this.$nextTick(() => {
          this.$refs.formAdd.clearValidate()
        })
      },
      deep: true,
      immediate: true,
    },
  },
  methods: {
    // 获取配置列表
    async getTypeList() {
      const [
        error,
        res,
      ] = await guidanceConfigurationDirectoryApi.guidanceConfigurationDirectoryNamesDto()
      if (!error) {
        this.typeList = res
      }
    },
    // 搜索
    handleChooseData() {
      if (!this.searchChooseData.title && !this.searchChooseData.directoryId) {
        this.chooseFilterList = this.formData.chooseList
      } else if (this.searchChooseData.title && !this.searchChooseData.directoryId) {
        this.chooseFilterList = this.formData.chooseList.filter((item) => {
          return item.title.includes(this.searchChooseData.title)
        })
      } else if (this.searchChooseData.directoryId && !this.searchChooseData.title) {
        this.chooseFilterList = this.formData.chooseList.filter((item) => {
          return item.directoryName === this.searchChooseData.directoryId
        })
      } else {
        this.chooseFilterList = this.formData.chooseList.filter((item) => {
          return (
            item.directoryName === this.searchChooseData.directoryId &&
            item.title.includes(this.searchChooseData.title)
          )
        })
      }
    },
    // 搜索
    handleSearch() {
      this.getConfigList()
    },
    // 删除
    handleDel(row) {
      const index = this.formData.chooseList.findIndex((item) => {
        return item.id === row.id
      })
      if (index !== -1) {
        this.formData.chooseList.splice(index, 1)
      }
      const data = find(this.dataList, { id: row.id })
      if (data) {
        this.$refs.tables.toggleRowSelection(data, false)
      }
      this.searchChooseData = {
        title: '',
        directoryId: '',
      }
      this.handleChooseData()
      this.$nextTick(() => {})
    },
    // 事件-选中
    choose() {
      if (this.selection.length === 0) {
        this.$message({
          showClose: true,
          message: '请勾选所需资质模板类型',
          type: 'warning',
        })
        return
      }
      const chooseList = [...this.selection, ...this.formData.chooseList]
      this.formData.chooseList = chooseList.reduce((all, next) => {
        return all.some((item) => {
          return item.id === next.id
        })
          ? all
          : [...all, next]
      }, [])
      this.handleChooseData()
    },
    // 禁用复选框
    isDisabled(row) {
      const selection = this.formData.chooseList.map((item) => {
        return item.configurationId
      })
      if (selection.includes(row.configurationId)) {
        return 0
      }
      return 1
    },
    // 选中复制到选中列表
    selectChange(val) {
      console.log(val)
      this.selection = uniqBy(val, 'id')
    },
    // 获取承包商信息列表
    async getConfigList() {
      const [error, res] = await guidanceConfigurationApi.pagedListQuery({
        skipCount: 0,
        maxResultCount: 999,
        ...this.searchData,
      })
      if (!error) {
        res.items.forEach((item) => {
          item.directoryId = item.id
          item.configurationId = item.id
        })
        this.dataList = res.items
        console.log(this.formData.chooseList)
        this.chooseFilterList = this.formData.chooseList || []
        this.$nextTick(() => {
          this.$refs.tables.clearSelection()
          _.forEach(this.formData.chooseList, (item) => {
            const data = find(this.dataList, { id: item.id })
            if (data) {
              this.$refs.tables.toggleRowSelection(data, true)
            }
          })
        })
      }
    },
    // 保存
    handleSave() {
      this.$refs.formAdd.validate((valid) => {
        if (valid) {
          if (this.formData.chooseList.length === 0) {
            this.$message({
              showClose: true,
              message: '请勾选资质模板类型',
              type: 'warning',
            })
            return
          }
          this.saveForm()
        }
      })
    },
    // 接口保存表单
    async saveForm() {
      this.formLoading = true
      let [error, res] = [null, null]
      if (this.pageType === 'create') {
        ;[error, res] = await profileTemplateConfigurationApi.create({
          body: {
            templateName: this.formData.templateName,
          },
        })
      } else {
        ;[error, res] = await profileTemplateConfigurationApi.update(this.formData.id, {
          body: {
            templateName: this.formData.templateName,
            id: this.formData.id,
          },
        })
      }

      if (!error) {
        const params = this.formData.chooseList.map((item) => {
          return {
            configurationId: item.id,
            templateId: this.pageType === 'create' ? res.id : this.formData.id,
          }
        })
        const [err, result] = await profileTemplateGuidanceConfigurationApi.manyAndDelete({
          body: params,
        })
        if (!err) {
          this.$message({
            showClose: true,
            message: this.pageType === 'create' ? '新增成功' : '编辑成功',
            type: 'success',
          })
          this.$emit('save')
          this.formLoading = false
        }
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.title {
  position: relative;
  &::before {
    position: absolute;
    content: '';
    width: 2px;
    height: 70%;
    left: -8px;
    top: 4px;
    background-color: #0082f7;
  }
}

.custom-height {
  height: calc(100% - 50px);
}

.form-nolabel {
  ::v-deep .el-form-item__content {
    margin-left: 0 !important;
  }
}
</style>
